// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qT-z","hovered":"rT-z","hoverImage":"sT-z","mainImage":"tT-z","imageNoBackground":"uT-z","fullSizeImage":"vT-z"};